import './polyfills';
import 'reflect-metadata';
import { initARMS } from '@patsnap-utils/ali-arms';
import './styles';
import { injectService } from '@/inversify.config';
import './inversify/index';
import Vue from 'vue';
import { router, addRoutes } from './routers';
import { i18nSymbol } from './i18n';
import hackPopupManager from '@/infrastructure/utils/hackPopupManager';
import ptDialogAutoMounterManager, { DialogAutoMounterManager } from './services/PtDialogAutoMounterManager';
import '@patsnap-ui/icon/assets/solid/BookmarkBook.svg';
import { WorkspaceStartupSymbol } from './startup/index';
import { UserGuideService } from './domains/user-guide/key-features/types/user-guide-service.interface';
import AiTaggingTourContainer from '@/presentation/components/user-guid/components/ai-tagging-tour/AiTaggingTourContainer.vue';
import { CommandRegistry } from '@patsnap/tahiti-core/common/command';
import { ErrorHandlerRegistry } from '@patsnap/tahiti-core/common/error-handler-contribution';
import { ErrorHandler } from '@patsnap/tahiti-core/common/error-handler';
import { SpaceActionRegistry } from '@/services/space-action-contribution';
import { useTippyTooltip } from '@/presentation/composables/use-tippy-tooltip';
import { FullscreenServiceSymbol } from './services/FullscreenService';
import { useDisposes } from './presentation/composables/use-disposes';
import { Disposable } from '@patsnap/tahiti-core';
function initARMSFun() {
    const enableArms = window.location.hostname.includes('zhihuiya.com');
    if (enableArms) {
        initARMS({
            pid: process.env.VUE_APP_ARMS_PID,
            endpoint: process.env.VUE_APP_ARMS_ENDPOINT,
            spaMode: 'history',
        });
    }
}
initARMSFun();
hackPopupManager();
Vue.prototype.$eventHub = new Vue();
window.Bus = Vue.prototype.$eventHub;
(async () => {
    const i18n = injectService(i18nSymbol);
    const startup = injectService(WorkspaceStartupSymbol);
    const userGuideService = injectService(UserGuideService);
    await startup.init();
    await startup.initI18n();
    await startup.initPrepareData();
    addRoutes(router);
    import('@/infrastructure/utils/vue-filters').then(({ installFilters }) => {
        installFilters(Vue);
    });
    new Vue({
        setup() {
            const { initTippyTooltip } = useTippyTooltip();
            const fullscreenService = injectService(FullscreenServiceSymbol);
            fullscreenService.init();
            const { disposes } = useDisposes();
            disposes.push(Disposable.create(() => {
                fullscreenService.destroy();
            }));
            return {
                initTippyTooltip,
            };
        },
        // @ts-ignore todo
        router,
        i18n,
        created() {
            userGuideService.init();
            this.initTippyTooltip();
            injectService(CommandRegistry).onStart();
            injectService(ErrorHandlerRegistry).onStart();
            injectService(ErrorHandler).onStart();
            injectService(SpaceActionRegistry).onStart();
        },
        render() {
            return <div class={'app-container-wrapper bg-white'}>
                <router-view />
                <DialogAutoMounterManager.MountPoint service={ptDialogAutoMounterManager}/>
                {/* @ts-ignore todo */}
                <AiTaggingTourContainer />
            </div>;
        },
    }).$mount('#app');
})();
